import { default as indexAoLMGaqkbyMeta } from "/app/pages/career/chats/[id]/index.vue?macro=true";
import { default as indexMudYDa1PcgMeta } from "/app/pages/career/chats/index.vue?macro=true";
import { default as indexQWqL28YepKMeta } from "/app/pages/career/job_postings/[id]/index.vue?macro=true";
import { default as indexW4iuRRtrG6Meta } from "/app/pages/career/job_postings/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as mypagePUVL2mOAibMeta } from "/app/pages/mypage.vue?macro=true";
import { default as _91id_93Kujv0wYEYHMeta } from "/app/pages/profile/[id].vue?macro=true";
import { default as editu0DrhghcWFMeta } from "/app/pages/profile/add_service/edit.vue?macro=true";
import { default as edit7WikgKtIQlMeta } from "/app/pages/profile/basic/edit.vue?macro=true";
import { default as edit1Vu8hpgxWOMeta } from "/app/pages/profile/certifications_awards/edit.vue?macro=true";
import { default as editbUooxexoBEMeta } from "/app/pages/profile/edit.vue?macro=true";
import { default as editH2tns1kLxNMeta } from "/app/pages/profile/history_logs/edit.vue?macro=true";
import { default as editrmK8F9zSG7Meta } from "/app/pages/profile/job/about_myself/edit.vue?macro=true";
import { default as editmYLUXkmoUIMeta } from "/app/pages/profile/job/important/edit.vue?macro=true";
import { default as editG59hY44rqUMeta } from "/app/pages/profile/job/requirement/edit.vue?macro=true";
import { default as edittUP3NDiFshMeta } from "/app/pages/profile/job/salary/edit.vue?macro=true";
import { default as editk49OhWdRc4Meta } from "/app/pages/profile/job/status/edit.vue?macro=true";
import { default as edit8vzW9Q6gqlMeta } from "/app/pages/profile/necessary_items/edit.vue?macro=true";
import { default as edit7LDktFDiTEMeta } from "/app/pages/profile/resume/edit.vue?macro=true";
import { default as reportdPmEn6igepMeta } from "/app/pages/report.vue?macro=true";
import { default as _91token_93hDnpsAn81qMeta } from "/app/pages/submission/[token].vue?macro=true";
import { default as testL3AVDvhyXeMeta } from "/app/pages/test.vue?macro=true";
import { default as indexdE4KZzyh0FMeta } from "/app/pages/ticket-box/completed/[token]/index.vue?macro=true";
import { default as indexV3xQjgaySnMeta } from "/app/pages/ticket-box/index.vue?macro=true";
export default [
  {
    name: indexAoLMGaqkbyMeta?.name ?? "career-chats-id",
    path: indexAoLMGaqkbyMeta?.path ?? "/career/chats/:id()",
    meta: indexAoLMGaqkbyMeta || {},
    alias: indexAoLMGaqkbyMeta?.alias || [],
    redirect: indexAoLMGaqkbyMeta?.redirect || undefined,
    component: () => import("/app/pages/career/chats/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexMudYDa1PcgMeta?.name ?? "career-chats",
    path: indexMudYDa1PcgMeta?.path ?? "/career/chats",
    meta: indexMudYDa1PcgMeta || {},
    alias: indexMudYDa1PcgMeta?.alias || [],
    redirect: indexMudYDa1PcgMeta?.redirect || undefined,
    component: () => import("/app/pages/career/chats/index.vue").then(m => m.default || m)
  },
  {
    name: indexQWqL28YepKMeta?.name ?? "career-job_postings-id",
    path: indexQWqL28YepKMeta?.path ?? "/career/job_postings/:id()",
    meta: indexQWqL28YepKMeta || {},
    alias: indexQWqL28YepKMeta?.alias || [],
    redirect: indexQWqL28YepKMeta?.redirect || undefined,
    component: () => import("/app/pages/career/job_postings/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexW4iuRRtrG6Meta?.name ?? "career-job_postings",
    path: indexW4iuRRtrG6Meta?.path ?? "/career/job_postings",
    meta: indexW4iuRRtrG6Meta || {},
    alias: indexW4iuRRtrG6Meta?.alias || [],
    redirect: indexW4iuRRtrG6Meta?.redirect || undefined,
    component: () => import("/app/pages/career/job_postings/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect || undefined,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login",
    path: loginhHM0vSTW5jMeta?.path ?? "/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect || undefined,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: mypagePUVL2mOAibMeta?.name ?? "mypage",
    path: mypagePUVL2mOAibMeta?.path ?? "/mypage",
    meta: mypagePUVL2mOAibMeta || {},
    alias: mypagePUVL2mOAibMeta?.alias || [],
    redirect: mypagePUVL2mOAibMeta?.redirect || undefined,
    component: () => import("/app/pages/mypage.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Kujv0wYEYHMeta?.name ?? "profile-id",
    path: _91id_93Kujv0wYEYHMeta?.path ?? "/profile/:id()",
    meta: _91id_93Kujv0wYEYHMeta || {},
    alias: _91id_93Kujv0wYEYHMeta?.alias || [],
    redirect: _91id_93Kujv0wYEYHMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/[id].vue").then(m => m.default || m)
  },
  {
    name: editu0DrhghcWFMeta?.name ?? "profile-add_service-edit",
    path: editu0DrhghcWFMeta?.path ?? "/profile/add_service/edit",
    meta: editu0DrhghcWFMeta || {},
    alias: editu0DrhghcWFMeta?.alias || [],
    redirect: editu0DrhghcWFMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/add_service/edit.vue").then(m => m.default || m)
  },
  {
    name: edit7WikgKtIQlMeta?.name ?? "profile-basic-edit",
    path: edit7WikgKtIQlMeta?.path ?? "/profile/basic/edit",
    meta: edit7WikgKtIQlMeta || {},
    alias: edit7WikgKtIQlMeta?.alias || [],
    redirect: edit7WikgKtIQlMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/basic/edit.vue").then(m => m.default || m)
  },
  {
    name: edit1Vu8hpgxWOMeta?.name ?? "profile-certifications_awards-edit",
    path: edit1Vu8hpgxWOMeta?.path ?? "/profile/certifications_awards/edit",
    meta: edit1Vu8hpgxWOMeta || {},
    alias: edit1Vu8hpgxWOMeta?.alias || [],
    redirect: edit1Vu8hpgxWOMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/certifications_awards/edit.vue").then(m => m.default || m)
  },
  {
    name: editbUooxexoBEMeta?.name ?? "profile-edit",
    path: editbUooxexoBEMeta?.path ?? "/profile/edit",
    meta: editbUooxexoBEMeta || {},
    alias: editbUooxexoBEMeta?.alias || [],
    redirect: editbUooxexoBEMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/edit.vue").then(m => m.default || m)
  },
  {
    name: editH2tns1kLxNMeta?.name ?? "profile-history_logs-edit",
    path: editH2tns1kLxNMeta?.path ?? "/profile/history_logs/edit",
    meta: editH2tns1kLxNMeta || {},
    alias: editH2tns1kLxNMeta?.alias || [],
    redirect: editH2tns1kLxNMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/history_logs/edit.vue").then(m => m.default || m)
  },
  {
    name: editrmK8F9zSG7Meta?.name ?? "profile-job-about_myself-edit",
    path: editrmK8F9zSG7Meta?.path ?? "/profile/job/about_myself/edit",
    meta: editrmK8F9zSG7Meta || {},
    alias: editrmK8F9zSG7Meta?.alias || [],
    redirect: editrmK8F9zSG7Meta?.redirect || undefined,
    component: () => import("/app/pages/profile/job/about_myself/edit.vue").then(m => m.default || m)
  },
  {
    name: editmYLUXkmoUIMeta?.name ?? "profile-job-important-edit",
    path: editmYLUXkmoUIMeta?.path ?? "/profile/job/important/edit",
    meta: editmYLUXkmoUIMeta || {},
    alias: editmYLUXkmoUIMeta?.alias || [],
    redirect: editmYLUXkmoUIMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/job/important/edit.vue").then(m => m.default || m)
  },
  {
    name: editG59hY44rqUMeta?.name ?? "profile-job-requirement-edit",
    path: editG59hY44rqUMeta?.path ?? "/profile/job/requirement/edit",
    meta: editG59hY44rqUMeta || {},
    alias: editG59hY44rqUMeta?.alias || [],
    redirect: editG59hY44rqUMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/job/requirement/edit.vue").then(m => m.default || m)
  },
  {
    name: edittUP3NDiFshMeta?.name ?? "profile-job-salary-edit",
    path: edittUP3NDiFshMeta?.path ?? "/profile/job/salary/edit",
    meta: edittUP3NDiFshMeta || {},
    alias: edittUP3NDiFshMeta?.alias || [],
    redirect: edittUP3NDiFshMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/job/salary/edit.vue").then(m => m.default || m)
  },
  {
    name: editk49OhWdRc4Meta?.name ?? "profile-job-status-edit",
    path: editk49OhWdRc4Meta?.path ?? "/profile/job/status/edit",
    meta: editk49OhWdRc4Meta || {},
    alias: editk49OhWdRc4Meta?.alias || [],
    redirect: editk49OhWdRc4Meta?.redirect || undefined,
    component: () => import("/app/pages/profile/job/status/edit.vue").then(m => m.default || m)
  },
  {
    name: edit8vzW9Q6gqlMeta?.name ?? "profile-necessary_items-edit",
    path: edit8vzW9Q6gqlMeta?.path ?? "/profile/necessary_items/edit",
    meta: edit8vzW9Q6gqlMeta || {},
    alias: edit8vzW9Q6gqlMeta?.alias || [],
    redirect: edit8vzW9Q6gqlMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/necessary_items/edit.vue").then(m => m.default || m)
  },
  {
    name: edit7LDktFDiTEMeta?.name ?? "profile-resume-edit",
    path: edit7LDktFDiTEMeta?.path ?? "/profile/resume/edit",
    meta: edit7LDktFDiTEMeta || {},
    alias: edit7LDktFDiTEMeta?.alias || [],
    redirect: edit7LDktFDiTEMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/resume/edit.vue").then(m => m.default || m)
  },
  {
    name: reportdPmEn6igepMeta?.name ?? "report",
    path: reportdPmEn6igepMeta?.path ?? "/report",
    meta: reportdPmEn6igepMeta || {},
    alias: reportdPmEn6igepMeta?.alias || [],
    redirect: reportdPmEn6igepMeta?.redirect || undefined,
    component: () => import("/app/pages/report.vue").then(m => m.default || m)
  },
  {
    name: _91token_93hDnpsAn81qMeta?.name ?? "submission-token",
    path: _91token_93hDnpsAn81qMeta?.path ?? "/submission/:token()",
    meta: _91token_93hDnpsAn81qMeta || {},
    alias: _91token_93hDnpsAn81qMeta?.alias || [],
    redirect: _91token_93hDnpsAn81qMeta?.redirect || undefined,
    component: () => import("/app/pages/submission/[token].vue").then(m => m.default || m)
  },
  {
    name: testL3AVDvhyXeMeta?.name ?? "test",
    path: testL3AVDvhyXeMeta?.path ?? "/test",
    meta: testL3AVDvhyXeMeta || {},
    alias: testL3AVDvhyXeMeta?.alias || [],
    redirect: testL3AVDvhyXeMeta?.redirect || undefined,
    component: () => import("/app/pages/test.vue").then(m => m.default || m)
  },
  {
    name: indexdE4KZzyh0FMeta?.name ?? "ticket-box-completed-token",
    path: indexdE4KZzyh0FMeta?.path ?? "/ticket-box/completed/:token()",
    meta: indexdE4KZzyh0FMeta || {},
    alias: indexdE4KZzyh0FMeta?.alias || [],
    redirect: indexdE4KZzyh0FMeta?.redirect || undefined,
    component: () => import("/app/pages/ticket-box/completed/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: indexV3xQjgaySnMeta?.name ?? "ticket-box",
    path: indexV3xQjgaySnMeta?.path ?? "/ticket-box",
    meta: indexV3xQjgaySnMeta || {},
    alias: indexV3xQjgaySnMeta?.alias || [],
    redirect: indexV3xQjgaySnMeta?.redirect || undefined,
    component: () => import("/app/pages/ticket-box/index.vue").then(m => m.default || m)
  }
]